import { render, staticRenderFns } from "./Retailer.vue?vue&type=template&id=106c7e6f&"
import script from "./Retailer.vue?vue&type=script&lang=js&"
export * from "./Retailer.vue?vue&type=script&lang=js&"
import style0 from "./Retailer.vue?vue&type=style&index=0&id=106c7e6f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports